export enum IconModal {
  Check = 'check',
  CheckCircle = 'check-circle',
  AlertTriangle = 'alert-triangle',
  MessageSquare = 'message-square',
  Info = 'info',
  Spiner = 'spinner',
  Airplay = 'airplay',
  Download = 'download',
  Share = 'share-2',
}
